import React from 'react';

export const SaraLogo = ({ variant = "dark", size = "default" }) => {
  const isDark = variant === "dark";
  const isLarge = size === "large";

  return (
    <div className="flex items-center gap-3">
      {/* Logo mark: stylized S with teal/orange accent */}
      <div className={`${isLarge ? 'w-12 h-12' : 'w-10 h-10'} rounded-xl relative overflow-hidden flex items-center justify-center flex-shrink-0`}
        style={{ background: 'linear-gradient(135deg, hsl(185 72% 38%), hsl(185 60% 48%))' }}
      >
        {/* Orange accent dot */}
        <div className="absolute top-1 right-1 w-2 h-2 rounded-full bg-warm" />
        <span className={`text-primary-foreground font-bold ${isLarge ? 'text-xl' : 'text-lg'} tracking-tight relative z-10`}>S</span>
      </div>
      <div className="flex flex-col leading-tight">
        <span className={`font-semibold ${isLarge ? 'text-lg' : 'text-base'} tracking-tight ${
          isDark ? "text-[hsl(220_15%_95%)]" : "text-foreground"
        }`}>
          Sara Advertising
        </span>
        <span className={`font-bold ${isLarge ? 'text-sm' : 'text-xs'} tracking-[0.2em]`}
          style={{ color: 'hsl(24 90% 55%)' }}
        >PPC</span>
      </div>
    </div>
  );
};
